import { PlayCircleFilled } from "@mui/icons-material";
import { Box } from "@mui/material";
import { CSSProperties, useState } from "react";

const VideoThumbnail = ({
  url,
  onClick,
}: {
  url?: string;
  onClick?: () => void;
}) => {
  const [onHover, setOnHover] = useState(false);

  let imgStyles: CSSProperties = {
    width: 180,
    height: 101.25,
    objectFit: "cover",
    borderRadius: 0.5,
  };

  if (onHover) {
    imgStyles = {
      ...imgStyles,
      filter: "brightness(0.9)",
      boxShadow: "0 0 10px 5px rgba(0, 0, 0, 0.5)",
    };
  }

  return (
    <div
      onMouseEnter={() => setOnHover(true)}
      onMouseLeave={() => setOnHover(false)}
      style={{
        position: "relative",
        display: "inline-block",
        cursor: "pointer",
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      <Box
        component="img"
        src={url || "https://via.placeholder.com/120x67"}
        alt={"Video Thumbnail"}
        sx={imgStyles}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textDecoration: "underline",
          fontWeight: "bold",
          textAlign: "center",
          opacity: onHover ? 1 : 0.7,
        }}
      >
        <PlayCircleFilled fontSize="large" />
      </div>
    </div>
  );
};

export default VideoThumbnail;
